(function( $ ) {
   "use strict";

   FTFThemeSP.reviewOther = function () {
      // any code css
      // 1. Areviews - Reviews Importer
      // if ($('.areviews_product_item').length > 0 && typeof show_infiniti_areviews === 'function'){show_infiniti_areviews();}
   };


})( jQuery_F2NT );

jQuery_F2NT(document).ready(function($) {
   jQuery_F2NT('body').on('reloadReview.ftf', FTFThemeSP.reviewOther );
});

